








































































































































































































































declare var window: any;
import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import VueToastr from '@deveodk/vue-toastr';
import { vxm } from './../store.vuex';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import router from '../router';
import Avatar from 'vue-avatar';
import { SIDE_MENU_ROUTE_MAPPER } from '@/models/configs/RoutersMap';
import { AVAILABLE_SIDEMENU_OPTIONS } from '@/components/Commons/availableSideMenuOptions';

@Component({
  name: 'SideMenu',
  components: { Avatar },
})
export default class SideMenu extends Vue {
  $wlToastr: any;

  private ALIAS_TO_SECTION_KEY_MAPPER = {
    findJobs: 'FIND_JOBS',
    referafriend: 'REFER_A_FRIEND',
    myJobs: 'MY_JOBS',
    myReferrals: 'MY_REFERRALS',
    job_alerts: 'JOB_ALERTS',
    savedJobs: 'SAVED_JOBS',
    chat: 'INBOX',
  };

  get showProfileWizardLink() {
    return false;
  }
  get applicationName() {
    return vxm.configs.getGlobalConfigValue(
      'WL_CANDIDATE_PORTAL_APPLICATION_NAME',
    );
  }

  get showAvatar() {
    return (
      !vxm.users.myUserProfile.profilePicGUID || !this.uploadProfileFileUrl
    );
  }
  rudderStackEventTrigger(value) {
    vxm.users.Rudderstack.trackEvent(`clicked on ${value === 'Profile' ? value : this.getMenuText(value)}`, {});
    if (typeof value === 'object' && value.externalLink) {
      window.open(value.externalLink, '_blank');
      this.$router.go(-1);
    }
    if (vxm.jobs.BrandingInfo.OPEN_TIMESHEET_IN_NEW_TAB && value.alias === 'timesheets') { 
      const currentDomain = window.location.origin;
      window.open(currentDomain + '/atsuser/candidate-timesheet', '_blank');
      this.$router.go(-1);
    }
      
}
  get profileLink() {
    return vxm.configs.getGlobalConfigValue('ENABLE_USER_PROFILE_V2')
      ? '/myprofile/v2/details'
      : '/myprofile/details';
  }

  menuLink(name) {
    if (name === 'JOB_ALERTS') {
      const jobAlertURL = vxm.configs.ClientConfigs.globalConfig.config.find(
        (config) => config.key === 'ENABLE_JOBALERT_V2',
      );
      if (jobAlertURL && jobAlertURL.value) {
        return '/jobAlertV2';
      }
      return '/jobAlert';
    }
    if(name === 'TIMESHEETS' && vxm.configs.getGlobalConfigValue('EXTERNAL_TIMESHEETS')){
      return '/target-recruit-timesheet';
    }
    return SIDE_MENU_ROUTE_MAPPER[name];
  }

  get requiredStepsInfo() {
    return vxm.users.RequiredStepsInfo;
  }

  get requiredStepsHeader() {
    if (this.requiredStepsInfo.requiredStepsMissing.length) {
      return `You are ${this.requiredStepsInfo.requiredStepsMissing.length} ${
        this.requiredStepsInfo.requiredStepsMissing.length === 1
          ? 'step'
          : 'steps'
      } away!`;
    } else {
      return 'Well done!';
    }
  }

  get uploadProfileFileUrl() {
    return (
      vxm.users.myUserProfile.userProfileBasePath +
      vxm.users.myUserProfile.profilePicGUID +
      '.' +
      vxm.users.myUserProfile.profilePicExtType
    );
  }
  get FullName() {
    return (
      vxm.users.myUserProfile.firstName + ' ' + vxm.users.myUserProfile.lastName
    );
  }

  get percentComplete() {
    console.log(
      'profile strangth:' + vxm.users.myUserProfile.userProfileStrength,
    );
    return vxm.users.myUserProfile.userProfileStrength;
  }

  get isLoggedIn() {
    console.log('user is logged in ....', vxm.users.isLoggedIn);
    return vxm.users.isLoggedIn;
  }

  getImgUrl(name) {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return require('../assets/images2.0/menu-icons/' + name + '.svg');
    }
    return require('../assets/images2.0/menu-icons/' + name);
  }

  get dndStatus() {
    console.log(
      'getting dnd status:' + vxm.users.myUserProfile.availabilityStatus,
    );
    return vxm.users.myUserProfile.availabilityStatus;
  }

  logout() {
    const chatBotFrame: any = document.getElementById('myframe');
    let isUrlValid = false;
    try {
      new URL(window.WorkLLama.chatbotWidgetUrl);
      isUrlValid = true;
    } catch (_) {
      isUrlValid = false;
    }

    if (chatBotFrame && isUrlValid) {
      chatBotFrame.contentWindow.postMessage(
        'clear_email',
        window.WorkLLama.chatbotWidgetUrl,
      );
    }
    if (localStorage && localStorage.getItem('sender_id')) {
      localStorage.removeItem('sender_id');
    }
    console.log('user has logged off ....');
    vxm.users.logout();
    this.$router.push(
      vxm.configs.getGlobalConfigBooelanValue(
        'DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN',
      )
        ? '/login'
        : '/',
    );
  }

  get isConfigJSONEnabled() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return true;
    }
    return false;
  }

  get leftMenuOptions() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const config = vxm.configs.ClientConfigs.globalConfig.config.find(
        (config) => config.key === 'CHECK_USER_PROFILE_FORUM_ENABLED_FLAG',
      );
      if (config && config.value && !vxm.users.myUserProfile.enableForum) {
        this.lodash.remove(vxm.configs.ClientConfigs.slideMenuOptions, {
          sectionKey: 'FORUM',
        });
      }
      if(!vxm.configs.isReferralEnabled('REFERRAL_ENABLED')){
        this.lodash.remove(vxm.configs.ClientConfigs.slideMenuOptions,{sectionKey:'MY_REFERRALS',});
      }
      return vxm.configs.ClientConfigs.slideMenuOptions.filter((option) =>
        AVAILABLE_SIDEMENU_OPTIONS.includes(option.sectionKey),
      );
    }
    return vxm.utility.leftMenuOptions;
  }

  getMenuText(menu) {
    const appNameParam = {
      ApplicationName: this.applicationName,
    };
    let defaultText = '';

    let normalizedKey = '';
    if (this.isConfigJSONEnabled) {
      normalizedKey = menu.sectionKey.toLowerCase();
      defaultText = menu.displayName;
    } else {
      normalizedKey = this.ALIAS_TO_SECTION_KEY_MAPPER[menu.alias]
        ? this.ALIAS_TO_SECTION_KEY_MAPPER[menu.alias].toLowerCase()
        : menu.alias;
      defaultText = menu.text.replace(
        /{ApplicationName}/g,
        this.applicationName,
      );
    }
    const lang = this.$cookies.get('userLang') || 'en';
    if (lang === 'en') return defaultText;
    const label = this.$t(`sidemenu.${normalizedKey}`, appNameParam).toString();
    return label.indexOf('sidemenu') >= 0 ? defaultText : label;
  }

  mounted() {
    //vxm.users.isLoggedIn && vxm.users.refreshProfileInfo();
    // vxm.users.isLoggedIn && vxm.users.getProfileWizardStepInfo();
  }
}
